// ------------------------------------------------------
// Resolves the text to use for a variable (global & overrides)
//
// • Looks at variableConditions first (product / category / feature)
// • Falls back to the parent variable’s own text
// • Normalises every Craft-ID to Number so === comparisons work
//

export default function evaluateVariableConditions(variableEntry = {}, manualCtx = {}) {
  if (!variableEntry) return "";

  /* —–––– helpers —–––– */
  const num = v => Number(v); //  "5794" → 5794

  const {
    productId               = null,            // number | undefined
    productCategoryIds      = [],              // array<number>
    productFeatureIds       = [],              // array<number>
  } = manualCtx;

  /* Check if an ENTRY matches the current manual context */
  const matches = (entry = {}) => {
    /* ----- products ----- */
    const prodOk =
      !entry.showForTheFollowingProducts?.length ||
      entry.showForTheFollowingProducts.some(p => num(p.id) === num(productId));

    /* ----- categories ---- */
    const catOk =
      !entry.showForTheFollowingProductCategories?.length ||
      entry.showForTheFollowingProductCategories
           .some(c => productCategoryIds.map(num).includes(num(c.id)));

    /* ----- features ------ */
    const featOk =
      !entry.showForTheFollowingProductFeatures?.length ||
      entry.showForTheFollowingProductFeatures
           .some(f => productFeatureIds.map(num).includes(num(f.id)));

    return prodOk && catOk && featOk;
  };

  /* 1 ▸ walk through every variableCondition in order                */
  if (Array.isArray(variableEntry.variableConditions)) {
    for (const cond of variableEntry.variableConditions) {
      if (matches(cond)) {
        const txt = cond.plainText ?? "";
        /* If inheritIfEmpty is *false* OR we found non-empty text → done */
        if (txt || !cond.inheritIfEmpty) return txt;
        /* else continue to parent variable */
        break;
      }
    }
  }

  /* 2 ▸ finally consider the parent variable itself                   */
  return matches(variableEntry) ? (variableEntry.plainText ?? "") : "";
}
